"use client"
import React, {useState} from 'react';
import Image from "next/image";
import FullStarIcon from "@/public/icons/start-full.svg";
import AddNewComment from "@/components/ui/add-new-comment/add-new-comment";
import {SingleProductEnum} from "@/constants/commerce-enum";

type CommentProps = {
    rate?: string;
    count?: number;
    productId: number;
}

function ViewCountScoreCommentComponent({rate, count, productId}: CommentProps) {
    const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
    return (
        <>
            <div className="w-full flex  flex-wrap items-end gap-1 ">
                <h3 className='text-2xl font-bold'>{SingleProductEnum.usersComments} </h3>
                <span className='text font-medium text-gray-500'>({count})</span>
            </div>

            <div className='w-full items-center gap-1 mt-7 flex flex-wrap'>
                <h6 className={"text-xl font-bold"}>
                    {rate}
                </h6>
                <h6>
                    {SingleProductEnum.from}
                </h6>
                <h6>
                    ۵
                </h6>
                <Image src={FullStarIcon} width={27} height={27} alt={"FullStarIcon"} title={"FullStarIcon"}/>
            </div>

            <div className="w-full flex items-center text-sm mt-5 font-medium">
                {SingleProductEnum.addYourComment}
            </div>

            <div className="w-full flex flex-wrap items-center mt-3.5">
                <AddNewComment
                    id={productId}
                    title={SingleProductEnum.addComment}
                    isOpen={isCommentModalOpen}
                    onOpenChange={setIsCommentModalOpen}
                />
            </div>
        </>
    );
}

export default ViewCountScoreCommentComponent;